// src/App.js
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AnalyticsTracker from "./components/AnalyticsTracker";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Process from "./pages/Process";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

import RequireAuth from "./components/RequireAuth";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import RequestDetail from "./pages/admin/RequestDetail";
import ClientsOverview from "./pages/admin/ClientsOverview";
import ClientDetail from "./pages/admin/ClientDetail";
import ClientEdit from "./pages/admin/ClientEdit";
import ClientCreate from "./pages/admin/ClientCreate";
import EstimatesOverview from "./pages/admin/EstimatesOverview";
import EstimateCreate from "./pages/admin/EstimateCreate";
import EstimateDetail from "./pages/admin/EstimateDetail";
import EstimateEditor from "./pages/admin/EstimateEditor";
import InvoicesOverview from "./pages/admin/InvoicesOverview";
import InvoiceCreate from "./pages/admin/InvoiceCreate";
import InvoiceDetail from "./pages/admin/InvoiceDetail";
import InvoiceEditor from "./pages/admin/InvoiceEditor";
import QuoteEditor from "./pages/admin/QuoteEditor";

import PublicQuote from "./pages/PublicQuote";
import QuotesOverview from "./pages/admin/QuotesOverview";

export default function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <div
      className="site"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg.png)` }}
    >
      {!isAdminRoute && <Navbar />}
      <AnalyticsTracker />

      <main id="main" className="site-main">
        <Routes>
          {/* PUBLIC */}
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/process" element={<Process />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />

          {/* PUBLIC QUOTE VIEW */}
          <Route path="/quote/:quoteId" element={<PublicQuote />} />

          {/* ADMIN LOGIN */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* ADMIN (PROTECTED + NESTED) */}
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="requests/:id" element={<RequestDetail />} />
            <Route path="clients" element={<ClientsOverview />} />
            <Route path="clients/new" element={<ClientCreate />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="clients/:id/edit" element={<ClientEdit />} />
            <Route path="estimates" element={<EstimatesOverview />} />
            <Route path="estimates/new" element={<EstimateCreate />} />
            <Route path="estimates/:id" element={<EstimateDetail />} />
            <Route path="estimates/:id/edit" element={<EstimateEditor />} />
            <Route path="invoices" element={<InvoicesOverview />} />
            <Route path="invoices/new" element={<InvoiceCreate />} />
            <Route path="invoices/:id" element={<InvoiceDetail />} />
            <Route path="invoices/:id/edit" element={<InvoiceEditor />} />
            <Route path="quotes/:id" element={<QuoteEditor />} />
            <Route path="quotes" element={<QuotesOverview />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {!isAdminRoute && <Footer />}
    </div>
  );
}
